import { createOptionsFrom } from "@/lib/common/Option";

export const TransactionSummariesSortOrderLabels = {
	Alphabetical: "Alphabetical",
	MarketValue: "Total Value",
	UnitValue: "Unit Value",
	Gain: "Flat Gain",
	Quantity: "Quantity",
	CardNumber: "Card Number",
	PercentageGain: "Percentage Gain"
} as const;

export type TransactionSummariesSortOrder = keyof typeof TransactionSummariesSortOrderLabels;

export const TransactionSummariesSortOrderOptions = createOptionsFrom(TransactionSummariesSortOrderLabels);
